import React from "react";
import { Typography, Space, Tooltip } from "antd";
import PropTypes from "prop-types";
import { maskCNPJ } from "utils";

const ColumnEmployee = (props) => {
    const {info = null} = props;
    return (
    info ?
    <Tooltip title={info}>
        <Space direction="vertical" size={0}>
            <Typography.Text mark={info} style={{ fontSize: 12 }}>{props.name}</Typography.Text>
            <Typography.Text mark={info} style={{ fontSize: 12 }}>{props.email}</Typography.Text>
            <Typography.Text mark={info} style={{ fontSize: 12 }}>{props.cpf}</Typography.Text>
						{ props?.businessName && <Typography.Text mark={info} style={{ fontSize: 12 }}>{props.businessName}</Typography.Text> }
						{ props?.cnpj && <Typography.Text mark={info} style={{ fontSize: 12 }}>{maskCNPJ(props.cnpj)}</Typography.Text> }
        </Space>
    </Tooltip>
    :
    <Space direction="vertical" size={0}>
        <Typography.Text style={{ fontSize: 12 }}>{props.name}</Typography.Text>
        <Typography.Text style={{ fontSize: 12 }}>{props.email}</Typography.Text>
        <Typography.Text style={{ fontSize: 12 }}>{props.cpf}</Typography.Text>
				{ props?.businessName && <Typography.Text style={{ fontSize: 12 }}>{props.businessName}</Typography.Text> }
				{ props?.cnpj && <Typography.Text style={{ fontSize: 12 }}>{maskCNPJ(props.cnpj)}</Typography.Text> }
    </Space>
    );
};

ColumnEmployee.propTypes = {
    name: PropTypes.string.isRequired,
    email: PropTypes.string.isRequired,
    cpf: PropTypes.string.isRequired,
		cnpj: PropTypes.string,
		businessName: PropTypes.string
};

export { ColumnEmployee };
